<template>
  <div>
    <el-card class="mtf-head">
      <el-row :gutter="20">
        <el-col v-loading="statisticsloading" :span="6">
          <div class="accumulatedL custom-flex-space-between" style="background: rgb(235, 253, 238)">
            <div>
              <p class="ocean-content1">{{ $t('TankService.Businessquantity')+':'+formData.OrderCount + $t('TankService.Tickets') }}</p>
            </div>
            <img src="@/assets/gms/tankNo.png" style="width: 70px;height: 70px;margin-top: -8px;">
          </div>
        </el-col>
        <el-col v-loading="statisticsloading" :span="6">
          <div class="accumulatedL custom-flex-space-between" style="background: #ffefef">
            <div>
              <div class="ocean-content">{{ $t('TankService.Tankvolume')+':'+formData.TankCount +' (TEU)' }}</div>
              <div class="ocean-content">{{ $t('TankService.volume')+':'+formData.CBMCount+' (CBM)' }}</div>
            </div>
            <img src="@/assets/fms/2.png">
          </div>
        </el-col>
        <el-col v-loading="statisticsloading" :span="3">
          <div class="accumulatedR custom-flex border borderRadius">
            <div>
              <p class="label">{{ $t('TankService.Loading') }}</p>
              <div class="custom-flex-space-between svg">
                <img src="@/assets/fms/waybill_number.png" >
                <p class="content">{{ formData.ExchangeCount }}</p>
              </div>
            </div>
          </div>
        </el-col>
        <el-col v-loading="statisticsloading" :span="3">
          <div class="accumulatedR custom-flex border borderRadius">
            <div>
              <p class="label">{{ $t('TankService.Boarding') }}</p>
              <div class="custom-flex-space-between svg">
                <img src="@/assets/fms/booking.png" class="svgimg">
                <p class="content">{{ formData.BoardingCount }}</p>
              </div>
            </div>
          </div>
        </el-col>
        <el-col v-loading="statisticsloading" :span="3">
          <div class="accumulatedR custom-flex border borderRadius">
            <div>
              <p class="label">{{ $t('TankService.Arrival') }}</p>
              <div class="custom-flex-space-between svg">
                <img src="@/assets/fms/到港.png" >
                <p class="content">{{ formData.ArrivalCount }}</p>
              </div>
            </div>
          </div>
        </el-col>
        <el-col v-loading="statisticsloading" :span="3">
          <div class="accumulatedR custom-flex border borderRadius">
            <div>
              <p class="label">{{ $t('TankService.Unloading') }}</p>
              <div class="custom-flex-space-between svg">
                <img src="@/assets/fms/签收.png" >
                <p class="content">{{ formData.EmptyReturnCount }}</p>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </el-card>
    <el-row :gutter="10">
      <el-col :span="24">
        <el-card v-loading="businessloading" class="mt10 minheight350">
          <span class="fw600">{{ $t('TankService.Businessstatistics') }}</span>
          <div class="custom-flex-space-between mt16">
            <div class="customblue border borderRadius dian custom-flex-center">{{ $t('TankService.Tankboxticket') }}</div>
            <!-- <el-date-picker v-model="businessPickerTime" style="width: 220px;" class="custom-input" type="month" format="yyyy-MM" value-format="yyyyMM" :clearable="false" placeholder="月度" size="small" @change="businessChange" /> -->
          </div>
          <BarChart
            id="businessBar"
            ref="businessBar"
            left="3%"
            :yAxisMinInterval="1"
          />
        </el-card>
      </el-col>
      <el-col :span="24">
        <el-card v-loading="cbmloading" class="mt10 minheight350">
          <span class="fw600">{{ $t('TankService.Statisticsoftankvolume') }}</span>
          <div class="custom-flex-space-between mt16">
            <div class="customblue border borderRadius dian custom-flex-center">{{ $t('TankService.ProductName') +' ('+ $t('TankService.Tankvolume')+')' }}</div>
            <!-- <el-date-picker v-model="volumePickerTime" class="custom-input" style="width: 220px;" type="month" format="yyyy-MM" value-format="yyyyMM" :clearable="false" placeholder="月度" size="small" @change="volumeChange" /> -->
          </div>
          <BarChart
            id="volumeBar"
            ref="volumeBar"
            left="3%"
          />
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { getTDDataStatistics, getTDBusinessStatisticsTotal, getTDBusinessStatisticsCBMTotal } from '@/api/gmsTank.js'
import BarChart from '@/components/gms/barChart/index.vue'
import { FormatDate } from '@/utils/isClass'
export default {
  components: { BarChart },
  props: {
    timeDimension: {
      type: String,
      default: '1'
    },
    customerCode: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      lang: 'zh',
      formData: {},
      businessPickerTime: FormatDate(new Date()),
      volumePickerTime: FormatDate(new Date()),
      statisticsloading: false,
      businessloading: false,
      cbmloading: false
    }
  },
  computed: {},
  watch: {
    timeDimension(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.getDataStatistics()
        this.getBusinessTotal()
        this.getCBMTotal()
      }
    }
  },
  mounted() {
    this.lang = this.$ls.get('lang');
    this.init()
  },
  methods: {
    init() {
      this.getList()
    },
    getList() {
      this.getDataStatistics()
      this.getBusinessTotal()
      this.getCBMTotal()
    },
    /** 查询业务数量 */
    async getDataStatistics() {
      this.statisticsloading = true
      const params = { TimeDimension: this.timeDimension, CustomerCode: this.customerCode, lang: this.lang }
      var res = await getTDDataStatistics(params)
      if (res && res.isSuccess) {
        var data = res.data
        this.formData = data
        this.formData.count = data.fclCount + data.lclCount ?? 0
      } else {
        this.messagebox.alert($t('TankService.Content5'))
      }
      this.statisticsloading = false
    },
    /** 查询业务统计 */
    async getBusinessTotal() {
      this.businessloading = true
      const params = { TimeDimension: this.timeDimension, CustomerCode: this.customerCode, lang: this.lang }
      var res = await getTDBusinessStatisticsTotal(params)
      if (res && res.isSuccess) {
        var data = res.data
        data = data.map(item => {
          const name = item.Line
          return {
            ...item,
            name
          }
        })
        // 按数量排序
        data = data.sort((a, b) => b.Count - a.Count)
        // 取前10条数据 10条后的汇总为其他
        const top10Data = data.slice(0, 10)
        const totalCount = data.slice(10).reduce((sum, item) => sum + item.Count, 0)
        var dataName = top10Data.map(item => item.name)
        var dataSource = top10Data.map(item => item.Count)
        if (totalCount > 0) {
          dataName.push($t('TankService.Others'))
          dataSource.push(totalCount)
        }
        this.$refs.businessBar.chartInit(dataName, dataSource)
      } else {
        this.messagebox.alert($t('TankService.Content5'))
      }
      this.businessloading = false
    },
    /** 查询 箱量/体积统计 */
    async getCBMTotal() {
      this.cbmloading = true
      const params = { TimeDimension: this.timeDimension, CustomerCode: this.customerCode, lang: this.lang }
      var res = await getTDBusinessStatisticsCBMTotal(params)
      if (res && res.isSuccess) {
        var data = res.data
        data = data.map(item => {
          const count = item.TUESum
          const name = item.Line
          return {
            ...item,
            count,
            name
          }
        })
        // 按数量排序
        data = data.sort((a, b) => b.count - a.count)
        // 取前10条数据 10条后的汇总为其他
        const top10Data = data.slice(0, 20)
        const teutotal = data.slice(20).reduce((sum, item) => { return sum + item.count }, 0)
        var dataName = top10Data.map(item => item.name)
        var dataSource = top10Data.map(item => item.count)
        if (teutotal > 0) {
          dataName.push($t('TankService.TankvolumeOthers'))
          dataSource.push(teutotal)
        }

        this.$refs.volumeBar.chartInit(dataName, dataSource)
      } else {
        this.messagebox.alert($t('TankService.Content5'))
      }
      this.cbmloading = false
    },
    /** 业务统计时间选择时间 */
    businessChange() {
      this.getBusinessTotal()
    },
    /**  箱量/体积统计选择时间 */
    volumeChange() {
      this.getCBMTotal()
    }
  }
}
</script>
<style scoped>
.mtf1 {
  margin-top: -1px;
  border-top: #fff;
}
.mtf-head {
  margin-top: -1px;
  border-top: #fff;
}
.mtf-head >>> .el-card__body {
  padding: 0px 20px 20px 20px !important;
}

.mt10 {
  margin-top: 10px;
}
.mt16 {
  margin-top: 16px;
}
.fw600 {
  font-weight: 600;
}
.minheight350 {
  min-height: 350px;
}
.border {
  border: 1px solid #e5e7eb;
}
.borderRadius {
  border-radius: 10px;
}
.dian::before {
  content: '';
  display: inline-block;
  width: 5px;
  height: 5px;
  background: #58c6e4;
  border-radius: 50%;
  margin-right: 6px;
  margin-bottom: 2px;
}
.curMonth {
  padding: 10px 4px;
  background: #f6f6f8;
}
.elSelect {
  width: 180px;
  margin-left: 10px;
  border-radius: 8px;
}
.accumulatedL,
.accumulatedR {
  padding: 16px 24px;
  height: 88px;
}
.accumulatedL .label,
.accumulatedR .label {
  font-size: 12px;
  font-weight: 400;
  color: #4b5563;
}
.accumulatedL .content {
  font-size: 26px;
  font-weight: 600;
  color: #111827;
  margin-top: 14px;
}
.accumulatedR .content {
  font-size: 26px;
  font-weight: 600;
  color: #111827;
  margin: 10px 0 0 8px;
}
.accumulatedL img {
  width: 64px;
  height: 64px;
  display: inline-block;
}
.accumulatedR img {
  width: 30px;
  height: 30px;
  display: inline-block;
  margin-top: 14px;
}
.ocean-label{
  font-size: 13px;
  font-weight: 400;
  color: #4b5563;
}
.ocean-content1{
  font-size: 15px;
  font-weight: 600;
  color: #111827;
  margin: 23px 0 0 8px;
}
.ocean-content{
  font-size: 15px;
  font-weight: 600;
  color: #111827;
  margin: 8px 0 0 8px;
}
.svg{
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.svgimg{
    position: relative;
    left: -80px;
    filter: drop-shadow(#3809f3 80px 0);
}
.svgimgs{
    position: relative;
    left: -80px;
    filter: drop-shadow(green 80px 0);
}
</style>
